import type { WorkflowStatus, WorkflowMetadata } from '../hooks/useWorkflowMetadata';

/**
 * Get the queue name for a given status code from workflow metadata.
 *
 * - Works for either healthcare entity or provider queues based on `queueKey`.
 * - Safe: returns `undefined` if inputs are missing or not found.
 */
export function getQueueNameForStatus(
  statuses: WorkflowMetadata | undefined,
  statusCode?: string | null,
  queueKey: keyof Pick<
    WorkflowStatus,
    'healthcare_entity_queue_name' | 'provider_queue_name'
  > = 'healthcare_entity_queue_name'
): string | undefined {
  if (!statuses || !statusCode) return undefined;
  const match = statuses[statusCode];
  return match ? match[queueKey] : undefined;
}
